import React, { Component } from 'react';
import * as types from '../../constants'

export default class ControlLibraryActions extends Component {

  handleLanguageChange = (nextProps) => {
    if (nextProps.language !== this.props.language){
      this.setState({
        language: nextProps.language,
        languages: nextProps.languages,
        translations: nextProps.language.translations,
        languageName: nextProps.language.name,
        tableColumns: this.generateColumns()
      })
    }
  }

  handleLibraryControlActions = (nextProps) => {
    const prevActionType = this.props.library_control.action_type;
    const nextActionType = nextProps.library_control.action_type;
    if (prevActionType === nextActionType) return;

    switch (nextActionType){
      case types.GET_LIBRARY_CONTROLS_SUCCESS:
        return this.handleGetLibraryControlsSuccess(nextProps);
      case types.CREATE_LIBRARY_CONTROL_SUCCESS:
        return this.handleCreateLibraryControlSuccess();
      case types.UPDATE_LIBRARY_CONTROL_SUCCESS:
        return this.handleUpdateLibraryControlSuccess();
      case types.ARCHIVE_LIBRARY_CONTROL_SUCCESS:
        return this.handleArchiveLibraryControlSuccess();
      case types.UNARCHIVE_LIBRARY_CONTROL_SUCCESS:
        return this.handleUnarchiveLibraryControlSuccess();
      case types.GET_CONTROL_OWNERS_SUCCESS:
        return this.updateOwnerOptions(nextProps);
      case types.GET_CONTROL_TAGS_SUCCESS:
        return this.updateTagOptions(nextProps);
      case types.CREATE_LIBRARY_CONTROL_FAILURE:
        return this.handleLibraryControlFailure(nextProps);
      case types.UPDATE_LIBRARY_CONTROL_FAILURE:
        return this.handleLibraryControlFailure(nextProps);
      default: return;
    }

  }

  handleGetLibraryControlsSuccess = (nextProps) => {
    let { controls } = this.state;
    this.setState({
      controls: controls.concat(nextProps.library_control.library_controls),
      scroll: true
    })
  }

  handleCreateLibraryControlSuccess = () => {
    let { filters } = this.state;
    filters.page = 1;
    this.setState({ createControlShown: false, controls: [], scroll: false, filters }, this.getLibraryControlsAndRelatedRecords)
  }

  handleUpdateLibraryControlSuccess = () => {
    let { filters } = this.state;
    filters.page = 1
    this.setState({ updateControlShown: false, controls: [], scroll: false, filters }, this.getLibraryControlsAndRelatedRecords)
  }

  handleArchiveLibraryControlSuccess = () => {
    let { filters } = this.state;
    filters.page = 1
    this.setState({ confirmArchiveShown: false, controls: [], scroll: false, filters}, this.getLibraryControlsAndRelatedRecords)
  }

  handleUnarchiveLibraryControlSuccess = () => {
    let { filters } = this.state;
    filters.page = 1
    this.setState({ confirmUnarchiveShown: false, controls: [], scroll: false, filters }, this.getLibraryControlsAndRelatedRecords)
  }

  handleLibraryControlFailure = (nextProps) => {
    let { controlErrors } = this.state;
    controlErrors = nextProps.library_control.exception.response.data
    this.setState({ controlErrors })
  }

  hideControlUtilisation = () => {
    this.setState({ controlUtilisationShown: false })
  }

  showControlUtilisation = (control) => {
    this.setState({ controlUtilisationShown: true, control: control })
  }

  showUpdateControl = (control) => {
    this.setState({ updateControlShown: true, control: {...control}, controlErrors: {} })
  }

  hideUpdateControl = () => {
    this.setState({ updateControlShown: false })
  }

  showConfirmArchiveControl = (control) => {
    this.setState({ confirmArchiveShown: true, control: control})
  }

  hideConfirmArchiveControl = () => {
    this.setState({ confirmArchiveShown: false })
  }

  showConfirmUnarchiveControl = (control) => {
    this.setState({ confirmUnarchiveShown: true, control: control})
  }

  hideConfirmUnarchiveControl = () => {
    this.setState({ confirmUnarchiveShown: false })
  }

  showCreateControl = () => {
    this.setState({ 
      createControlShown: true,
      controlErrors: {},
      control: {
        custom_id: null,
        title: null,
        subtitle: null,
        description: null, 
        tag_list: [], 
        owner_list: [] 
      } 
    })
  }

  hideCreateControl = () => {
    this.setState({ createControlShown: false })
  }

  showTranslationsModal = () => {
    this.setState({ translationsModalShown: true })
  }

  hideTranslationsModal = () => {
    this.setState({ translationsModalShown: false })
  }

  getLibraryControls = () => {
    const { filters } = this.state;
    this.props.getLibraryControls(filters)
  }

  getMoreLibraryControls = () => {
    const { filters, controls, scroll } = this.state;

    if (!scroll) return

    if (controls.length > 0) {
      filters.page++; 
    } else {
      filters.page = 1; 
    }
    this.setState({ filters }, this.getLibraryControls)
  }

  handleSearchChange = (event, data) => {
    const { filters } = this.state;
    filters.search_term = data.value;
    filters.page = 1;
    this.setState({ filters, controls: [] }, this.getLibraryControls );
  }

  showArchivedLibraryControls = () => {
    const { filters } = this.state;
    filters.include_archived = true;
    filters.page = 1;
    this.setState({ filters, controls: [] }, this.getLibraryControls );
  }

  hideArchivedLibraryControls = () => {
    const { filters } = this.state;
    filters.include_archived = false;
    filters.page = 1;
    this.setState({ filters, controls: [] }, this.getLibraryControls );
  }

  handleControlChange = (evt) => {
    let { control } = this.state;
    control[evt.target.name] = evt.target.value
    this.setState({ control })
  }

  createLibraryControl = () => {
    const { control } = this.state;
    const control_copy = {...control}
    control_copy.tag_list = control.tag_list.toString();
    control_copy.owner_list = control.owner_list.toString();
    this.props.createLibraryControl(control_copy)
  }

  updateLibraryControl = () => {
    const { control } = this.state;
    const control_copy = {...control}
    control_copy.tag_list = control.tag_list.toString();
    control_copy.owner_list = control.owner_list.toString();
    this.props.updateLibraryControl(control_copy)
  }

  archiveLibraryControl = () => {
    const { control } = this.state;
    this.props.archiveLibraryControl(control.id)
  }

  unarchiveLibraryControl = () => {
    const { control } = this.state;
    this.props.unarchiveLibraryControl(control.id)
  }

  removeTag = (tag, control, saveNow) => {
    var tag_list = control.tag_list
    if (tag_list.includes(tag)) {
      var index = tag_list.indexOf(tag);
      if (index !== -1) tag_list.splice(index, 1);
    }
    this.updateTags(tag_list, control, saveNow)
  }

  updateTags = (tag_list, control, saveNow) => {
    control.tag_list = tag_list
    if (saveNow) {
      this.setState({ control }, this.updateLibraryControl)
    } else {
      this.setState({ control })
    }
  }

  createNewTag = (tag) => {
    const { defaultTagOptions } = this.state;
    if (!defaultTagOptions.includes(tag)){
      defaultTagOptions.unshift(tag)
      this.setState({ defaultTagOptions })
    }
  }

  removeOwner = (owner, control, saveNow) => {
    var owner_list = control.owner_list
    if (owner_list.includes(owner)) {
      var index = owner_list.indexOf(owner);
      if (index !== -1) owner_list.splice(index, 1);
    }
    this.updateOwners(owner_list, control, saveNow)
  }

  updateOwners = (owner_list, control, saveNow) => {
    control.owner_list = owner_list
    if (saveNow) {
      this.setState({ control }, this.updateLibraryControl)
    } else {
      this.setState({ control })
    }
  }

  createNewOwner = (owner) => {
    const { defaultOwnerOptions } = this.state;
    if (!defaultOwnerOptions.includes(owner)){
      defaultOwnerOptions.unshift(owner)
      this.setState({ defaultOwnerOptions })
    }
  }

  updateOwnerOptions = (nextProps) => {
    const { control_owners } = nextProps.library_control;
    const { defaultOwnerOptions } = this.state;
    control_owners.map((owner, index)=>{
      if (!defaultOwnerOptions.includes(owner.name)) {
        defaultOwnerOptions.push(owner.name)
      }
    })

    this.setState({ defaultOwnerOptions })
  }

  updateTagOptions = (nextProps) => {
    const { control_tags } = nextProps.library_control;
    const { defaultTagOptions } = this.state;
    control_tags.map((tag, index)=>{
      if (!defaultTagOptions.includes(tag.name)) {
        defaultTagOptions.push(tag.name)
      }
    })

    this.setState({ defaultTagOptions })
  }

  getLibraryControlsAndRelatedRecords = () => {
    this.getLibraryControls();
    this.props.getControlOwners()
    this.props.getControlTags()
  }

}


// WEBPACK FOOTER //
// ./src/views/control_library/control_library_actions.js